export const isBrowser = typeof window !== 'undefined'

export const scrollWithOffset = (id) => {
  const element = document.getElementById(id)
  if (element) {
    const offset = document.getElementById('header').offsetHeight
    const y =
      element.getBoundingClientRect().top + window.pageYOffset - (offset + 80)
    window.scrollTo({ top: y, behavior: 'smooth' })
  }
}

export const trackAdsConversion = ({ eventName, email, score }) => {
  if (!isBrowser) return
  if (BUILD_ENV !== 'production') return

  // Microsoft UET
  window.uetq = window.uetq || []
  window.uetq.push('event', eventName, {})
  console.warn('UET event tracked:', eventName)

  // Google Ads / GTM dataLayer
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: eventName,
    ...(email !== undefined && { user_data: { email } }),
    ...(score !== undefined && { lead_score: score })
  })
  console.warn('dataLayer event tracked:', eventName, { score })

  // Meta Pixel
  if (window.fbq) {
    window.fbq(
      'track',
      'Lead',
      ...(score !== undefined ? [{ lead_score: score }] : [])
    )
    console.warn('Meta Pixel Lead event tracked:', eventName)
  }
}

// score ≥ 65 → lead_top, 40–64 → lead_mid, < 40 → lead_low
export const leadTierEvent = (score) => {
  if (score >= 65) return 'lead_top'
  if (score >= 40) return 'lead_mid'
  return 'lead_low'
}

export const trackDataLayerEvent = (eventName, params = {}) => {
  if (!isBrowser) return
  if (BUILD_ENV !== 'production') return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: eventName, ...params })
  console.warn('dataLayer event tracked:', eventName, params)
}

/**
 * Track cookie consent events
 * @param {string} action - The action taken (accept_all, reject_all, accept_categories)
 * @param {Array} categories - Optional array of accepted categories
 */
export const trackCookieConsent = (action, categories = []) => {
  if (!isBrowser) return

  // Push to dataLayer for Google Tag Manager
  window.dataLayer = window.dataLayer || []
  const dataLayerEvent = {
    event: 'cookie_consent',
    consent_action: action,
    consent_categories: categories.length > 0 ? categories.join(',') : 'all',
    timestamp: new Date().toISOString()
  }
  window.dataLayer.push(dataLayerEvent)

  console.warn('[Cookie Consent] Tracked to dataLayer:', dataLayerEvent)
}

/**
 * Track button click events
 * @param {string} buttonName - The name/identifier of the button
 * @param {string} action - The action performed (e.g., 'click', 'navigate')
 * @param {Object} additionalParams - Optional additional parameters
 */
export const trackButtonClick = (
  buttonName,
  action = 'click',
  additionalParams = {}
) => {
  if (!isBrowser) return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'button_click',
    button_name: buttonName,
    button_action: action,
    timestamp: new Date().toISOString(),
    ...additionalParams
  })

  console.warn('Button click tracked:', {
    buttonName,
    action,
    ...additionalParams
  })
}

/**
 * Track link click events
 * @param {string} linkName - The name/identifier of the link
 * @param {string} destination - The destination URL or anchor
 * @param {Object} additionalParams - Optional additional parameters
 */
export const trackLinkClick = (
  linkName,
  destination,
  additionalParams = {}
) => {
  if (!isBrowser) return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'link_click',
    link_name: linkName,
    link_destination: destination,
    timestamp: new Date().toISOString(),
    ...additionalParams
  })

  console.warn('Link click tracked:', {
    linkName,
    destination,
    ...additionalParams
  })
}

export const BUILD_ENV = process.env.GATSBY_ENV || 'develop'

export const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/
